module.exports = __webpack_public_path__ + "img/layers-24px.b6d0e94a.svg";